"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BASE_URL: 'https://app.driftqa.com',
  BASE_DOMAIN: 'app.driftqa.com',
  CLIENT_ID: 'nwr5icbhx5d4ur',
  PUSH_WS: 'push.api.driftqa.com',
  RELEASE_URL: 'https://api.driftqa.com/releases',
  SENTRY_DSN: 'https://7325d27a5c424d9bacd9d2f0c8c6f016@sentry.io/1784185',
  IFRAMELY_API_KEY: 'f0f2cc6ba50c77794e5c5eb2930f3fd5',
  REDUX_STORE_PREFIX: 'convo'
};